import "./style.css";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useEffect, useState } from "react";
import RegistrationSchool from "../registration_school/screen";
import RegistrationCollegeProfessor from "../registration_college__professor/screen";
import RegistrationCollege from "../registration_college/screen";
import RegistrationIndustry from "../registration_industry/screen";
import RegistrationVisitor from "../registration_visitor/screen";
import RegistrationGovernmentOfficer from "../registration_govt_officers/screen";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../utils/firebase-config";
import { useNavigate, useLocation } from "react-router-dom";
import RegistrationTeacher from "../registration_teacher/screen";
import CustomTab from "../../components/CustomTab";
import { Backdrop, CircularProgress } from "@mui/material";
import { IITD_TITLE } from "../../utils/constants";
import BackButton from "../../components/back_button";
import RegistrationSponser from "../registration_sponser/screen";

export default function Registration() {
  const location = useLocation();
  const navigate = useNavigate();
  const [key, setKey] = useState("college");
  const [backdropOpen, setBackdropOpen] = useState(false);

  useEffect(() => {
    if (location.state !== null) {
      setKey(location.state);
    } else {
      navigate("/");
    }
  }, []);

  function getWidget() {
    switch (key) {
      // case "school":
      //   return (
      //     <RegistrationSchool
      //       loadingStatus={(status) => {
      //         setBackdropOpen(status);
      //       }}
      //     />
      //   );
      // case "teacher":
      //   return (
      //     <RegistrationTeacher
      //       loadingStatus={(status) => {
      //         setBackdropOpen(status);
      //       }}
      //     />
      //   );
      case "industry":
        return (
          <RegistrationIndustry
            loadingStatus={(status) => {
              setBackdropOpen(status);
            }}
          />
        );
      case "visitor":
        return (
          <RegistrationVisitor
            loadingStatus={(status) => {
              setBackdropOpen(status);
            }}
          />
        );
      case "sponser":
        return (
          <RegistrationSponser
            loadingStatus={(status) => {
              setBackdropOpen(status);
            }}
          />
        );
      // case "college":
      //   return (
      //     <RegistrationCollege
      //       loadingStatus={(status) => setBackdropOpen(status)}
      //     />
      //   );

      // case "college_professor":
      //   return (
      //     <RegistrationCollegeProfessor
      //       loadingStatus={(status) => setBackdropOpen(status)}
      //     />
      //   );
      case "GOVERNMENT_OFFICER":
        return (
          <RegistrationGovernmentOfficer
            loadingStatus={(status) => setBackdropOpen(status)}
          />
        );
      default:
        return (
          <RegistrationCollege
            loadingStatus={(status) => {
              setBackdropOpen(status);
            }}
          />
        );
    }
  }
  return (
    <div className="form-div">
      <div className="left-div">
        <BackButton />
        <h1>{IITD_TITLE}</h1>
        <h3 className="registration-type">{`${key} Registration`}</h3>
        {/* <Tabs
          className="controlled-tab-example mb-3"
          activeKey={key}
          onSelect={(k) => setKey(k)}
       
          justify
        >
          <Tab eventKey="school" title="School">
            <RegistrationSchool />
          </Tab>
          <Tab eventKey="teacher" title="Teacher">
            <RegistrationTeacher />
          </Tab>
          <Tab eventKey="industry" title="Industry">
            <RegistrationIndustry />
          </Tab>
          <Tab eventKey="visitor" title="Visitor">
            <RegistrationVisitor />
          </Tab>
        </Tabs> */}
        {getWidget()}
      </div>
      <div className="right-div">
        <img
          className="side-image"
          src="image/iitd-img.png"
          alt="IIT-Delhi"
        ></img>
      </div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backdropOpen}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
